import React from 'react';
import { StopOutlined, EyeOutlined } from "@ant-design/icons";
import { OpRow } from 'components/customAntd/DLS/OpRow/OpRow';
import { OpCol } from 'components/customAntd/DLS/OpCol/OpCol';
import { OpCard } from 'components/customAntd/DLS/OpCard/OpCard';
import { OpSpace } from 'components/customAntd/DLS/OpSpace/OpSpace';
import RedFlagReportCard from './RedFlagReportCard';
import { RedFlag } from 'types/redFlagTypes';
import { Visitor } from 'types/visitTypes';
import { useTranslation } from 'react-i18next';
import Loader from 'components/customAntd/Loader';

interface RedFlagReportSummaryProps {
    deniedVisitors: Visitor[];
    blockList: RedFlag[];
    watchList: RedFlag[];
    onDeniedClick: () => void;
    onBlockListClick: () => void;
    onWatchListClick: () => void;
    loading: boolean;
}

const RedFlagReportSummary: React.FC<RedFlagReportSummaryProps> = ({ deniedVisitors, blockList, watchList, onDeniedClick, onBlockListClick, onWatchListClick, loading }) => {
    const { t } = useTranslation();

    return (
        <OpSpace
            direction="vertical"
            size="middle"
            style={{ display: 'flex' }}
        >
            <OpCard type="inner" title={t('redFlagReport.summaryTitle')}>
                {loading ? (
                    <Loader />
                ) : (
                    <OpRow gutter={[16, 16]} justify="space-evenly">
                        <OpCol
                            xs={24}
                            sm={24}
                            md={6}
                            lg={6}
                            style={{ padding: '8px' }}
                        >
                            <RedFlagReportCard
                                icon={
                                    <StopOutlined
                                        style={{
                                            color: "white",
                                            backgroundColor: "rgba(242,103,87,1.0)",
                                            borderRadius: 20,
                                            fontSize: 24,
                                            padding: 8,
                                        }}
                                    />
                                }
                                title={t('redFlagReport.denied')}
                                value={deniedVisitors.length}
                                color="rgba(242,103,87,0.1)"
                                onClick={onDeniedClick}
                            />
                        </OpCol>
                        <OpCol
                            xs={24}
                            sm={24}
                            md={6}
                            lg={6}
                            style={{ padding: '8px' }}
                        >
                            <RedFlagReportCard
                                icon={
                                    <StopOutlined
                                        style={{
                                            color: "white",
                                            backgroundColor: "rgba(242,103,87,1.0)",
                                            borderRadius: 20,
                                            fontSize: 24,
                                            padding: 8,
                                        }}
                                    />
                                }
                                title={t('redFlagReport.addedToBlocklist')}
                                value={blockList.length}
                                color="rgba(242,103,87,0.1)"
                                onClick={onBlockListClick}
                            />
                        </OpCol>
                        <OpCol
                            xs={24}
                            sm={24}
                            md={6}
                            lg={6}
                            style={{ padding: '8px' }}
                        >
                            <RedFlagReportCard
                                icon={
                                    <EyeOutlined
                                        style={{
                                            color: "white",
                                            backgroundColor: "#FFD54F",
                                            borderRadius: 20,
                                            fontSize: 24,
                                            padding: 8,
                                        }}
                                    />
                                }
                                title={t('redFlagReport.addedToWatchlist')}
                                value={watchList.length}
                                color="rgba(255, 213, 79, 0.1)"
                                onClick={onWatchListClick}
                            />
                        </OpCol>
                    </OpRow>
                )}
            </OpCard>
        </OpSpace>

    );
}

export default RedFlagReportSummary;
